export const sortArrayWithNameFirst = (arr: string[], name: string) => {
  const arrWithName = arr.filter((s: string) => s.includes(name)).sort() || [];
  const arrWithoutName = arr.filter((s: string) => !s.includes(name)).sort() || [];

  return [...arrWithName, ...arrWithoutName];
};
